{
  "de": {
    "ticket_category": {
      "Decisions": "Entscheidung",
      "Issue": "Nachbetreuung",
      "Regular": "Allgemein",
      "labels": {
        "ticket_category": "Typ"
      }
    }
  }
}
